module.exports = __webpack_public_path__ + "static/media/22.321f6550.JPG";